import { useMutation } from "react-query";

import type { HcpServiceManager, PutServiceArgs } from "api/services/appointment/schemas/hcp_service";
import { useApiClient } from "api/useApiClient";

export const usePutService = () => {
  const client = useApiClient();

  return useMutation<HcpServiceManager, Error, PutServiceArgs>({ mutationFn: args => client.putService(args) });
};
